import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { PositionLoader } from '../../../infrastructure/services/loader/position-loader.interface';
import { LoaderService } from '../../../infrastructure/services/loader/loader.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    standalone: true,
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
    private readonly loader = inject(LoaderService);

    readonly loaderData = toSignal(this.loader.showLoader$, {
        initialValue: { flag: false, position: PositionLoader.center },
    });

    readonly show = computed(() => this.loaderData().flag);
    readonly position = computed(() => this.loaderData().position);
}
